import { BlocksIconPeople } from 'blocks-nextjs/blocks-web-components/components/icon/icons/people';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPeople = createComponent({ react: React, tagName: 'cat-icon-people', elementClass: BlocksIconPeople });
